import { render, staticRenderFns } from "./Voto.vue?vue&type=template&id=29c47b38"
import script from "./Voto.vue?vue&type=script&lang=js"
export * from "./Voto.vue?vue&type=script&lang=js"
import style0 from "./Voto.vue?vue&type=style&index=0&id=29c47b38&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports